module.exports = __webpack_public_path__ + "img/new-logo.fba4445a.png";